import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
/* import fetchHortatech from "../helpers/fetchHortatech";
import axios from "axios"; */
import { sensorCoordinates } from "data/sensor_data";
// import ProfilePicBlank from "assets/profile-pics/UserBlank.png";
import { useAuth } from "./AuthContext";
import {
  updateWidgetType,
  updateWidgetOptions,
  resetFrontLayout,
  setWidgetDefaultOptions,
} from "./functions/widgetFunctions";
import {
  addWidget,
  removeWidget,
  storeWidget,
  restoreStoredWidget,
} from "./functions/widgetDashboardFunctions";
import { availableWidgets, widgetData } from "data/chartData/frontLayout";

import { frontLayouts } from "data/frontLayouts";
import { usePageTitle } from "contexts/PageTitleContext";

import {
  loadProjectSensorData,
  mergeLatestSensorData,
  startSensorPolling,
  transformProjectSensorData,
} from "helpers/projectSensors";
// import {
//   setDynamicData,
//   getDynamicData,
// } from "data/chartData/unifiedDataSensors";

import { v4 as uuidv4 } from "uuid";
import { useHandleSetLayout } from "./functions/layoutFunctions";
import loadUserProfile from "components/authentication/loadUserProfile";
const StateContext = createContext();

const initialUserProfile = {
  userId: null,
  username: "",
  role: "admin",
  password: "",
  phone: "",
  email: "",
  profilePicture: "",
  parcela: "",
  poligono: "",
  catastro: "",
  parcels: [],
  parcela_orden: "",
  isOnline: true,
  userSettings: {
    apiCallFrequency: 5,
    enableNotifications: true,
    notificationChannels: {
      email: true,
      push: true,
      whatsapp: true,
    },
    notificationTypes: {
      watering: true,
      maintenance: true,
      incidents: true,
    },
    consentToCookies: true,
    consentToPersonalData: true,
    cookiePreferences: "essential", // "necessary", "preferences", "statistics", "marketing"
    whoCanContact: "everyone",
    darkMode: "system", // "light", "dark", "system" en db
    fontSize: "16px",
    sidebarPosition: "left", // "left" or "right" or maybe in the future - "bottom"
    // layoutMode: "queueWithMap",
    // dashboardLayout: frontLayouts["queueWithMap"], // should be "example-1 for demo" //sorted
    layoutMode: "advanced",
    dashboardLayout: frontLayouts["advanced"], // should be "example-1 for demo" //sorted
    widgets: widgetData,
    storedWidgets: [],
  },
  contactDetails: {
    firstName: "",
    lastName: "",
    workRole: "",
    bio: "",
    phone: "",
    contactMail: "",
    allowWhatsapp: true,

    address: {
      city: "",
      state: "",
      country: "",
      postalCode: "",
      street: "",
    },
  },
};

//console.log("ContextProvider initialUserProfile: ",initialUserProfile);

export const ContextProvider = ({ children }) => {
  const [activeLinkName, setActiveLinkName] = useState(() => {
    // Load from session storage
    const storedActiveLinkName = sessionStorage.getItem("activeLinkName");
    return storedActiveLinkName ? JSON.parse(storedActiveLinkName) : "Home"; // Default to "Home"
  });

  const [isEditingDashboardLayout, setIsEditingDashboardLayout] =
    useState(false); // Add state for draggability
  const { setPageTitle } = usePageTitle();

  const [activeLoginForm, setActiveLoginForm] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null); // Added state for selected profile
  const [selectedEventId, setSelectedEventId] = useState(""); // Added state for selected profile

  const [sensorsDataLatest, setSensorsDataLatest] = useState(null);
  const [sensorsDataLast5, setSensorsDataLast5] = useState(null);
  //const [dataLoaded, setDataLoaded] = useState(false);
  const [unifiedData, setUnifiedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUserPermissions, setIsLoadingUserPermissions] =
    useState(true);
  //States to handle user data between events
  const [userData, setUserData] = useState([]);

  const [latestUpdateTime, setLatestUpdateTime] = useState(new Date());

  useEffect(() => {}, [isLoadingUserPermissions]);

  const { isAuthenticated } = useAuth();
  //const [refreshData, setRefreshData] = useState(false);
  const [activeComponent, setActiveComponent] = useState("");

  // console.log("ContextProvider activeComponent", activeComponent);

  //-----MANAGE USER PROFILE-------
  //----GLOBAL STATE TO SAVE USER'S DATA

  const [userProfile, setUserProfile] = useState(() => {
    const storedUserProfile = JSON.parse(localStorage.getItem("userProfile"));
    return storedUserProfile || initialUserProfile;
  });
  const handleSetLayout = useHandleSetLayout(
    userProfile,
    setUserProfile,
    setActiveLinkName,
    setIsEditingDashboardLayout,
    setPageTitle
  );

  useEffect(() => {
    setIsLoadingUserPermissions(false);
    setIsLoading(false);
  }, [userProfile]);

  useEffect(() => {
    if (!isAuthenticated || !sessionStorage.getItem("accessToken")) return;
    loadUserProfile(setUserProfile, userProfile, setIsLoadingUserPermissions).catch((error) => {
      console.error("Error restoring user profile:", error);
    });
    // Authentication changes, rather than local profile edits, should trigger a
    // refresh from the Go API.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  //TEST trying to fix empty widgets due to widgetData not properly set for the user profile
  /* const [userProfile, setUserProfile] = useState(() => {
    const storedUserProfile = JSON.parse(localStorage.getItem("userProfile"));
    if (storedUserProfile) {
      return storedUserProfile;
    } else {
      // Initialize the widgets with the data available at start
      return {
        ...initialUserProfile,
        userSettings: {
          ...initialUserProfile.userSettings,
          widgets: widgetData(unifiedData),
        }
      };
    }
  }); */

  //console.log("ContextProvider userProfile: ", userProfile);

  useEffect(() => {
    //Load user profile from local storage
    const storedUserProfile = JSON.parse(localStorage.getItem("userProfile"));
    if (storedUserProfile) {
      setUserProfile(storedUserProfile);
    }
  }, []);

  useEffect(() => {
    //Load contactDetails from local storage
    const storedContactDetails = JSON.parse(
      localStorage.getItem("contactDetails")
    );
    if (storedContactDetails) {
      setUserProfile((prevProfile) => ({
        ...prevProfile,
        contactDetails: storedContactDetails,
      }));
    }
  }, []);

  useEffect(() => {
    //Load userSettings from local storage
    const storedUserSettings = JSON.parse(localStorage.getItem("userSettings"));
    if (storedUserSettings) {
      setUserProfile((prevProfile) => ({
        ...prevProfile,
        userSettings: storedUserSettings,
      }));
    }
  }, []);

  // Persist activeLinkName from local storage to state
  useEffect(() => {
    localStorage.setItem("activeLinkName", JSON.stringify(activeLinkName));
    console.log("ContextProvider useEffect activeLinkName", activeLinkName);
  }, [activeLinkName]);

  useEffect(() => {
    if (userProfile && userProfile.userSettings) {
      const newLayout = frontLayouts[userProfile.userSettings.layoutMode];
      setUserProfile((prevProfile) => ({
        ...prevProfile,
        userSettings: {
          ...prevProfile.userSettings,
          dashboardLayout: newLayout,
        },
      }));
    }
  }, [userProfile.userSettings.layoutMode]);

  useEffect(() => {
    // Load userSettings from local storage
    const activeLinkName = JSON.parse(localStorage.getItem("activeLinkName"));
    if (activeLinkName) {
      setUserProfile((prevProfile) => ({
        ...prevProfile,
        userSettings: {
          ...prevProfile.userSettings,
          dashboardLayout: frontLayouts[activeLinkName],
        },
      }));
    }
  }, []);

  useEffect(() => {
    //Save user profile to local storage
    localStorage.setItem("userProfile", JSON.stringify(userProfile));
  }, [userProfile]);

  useEffect(() => {
    //Save contactDetails to local storage
    localStorage.setItem(
      "contactDetails",
      JSON.stringify(userProfile.contactDetails)
    );
  }, [userProfile.contactDetails]);

  useEffect(() => {
    //Save userSettings to local storage
    localStorage.setItem(
      "userSettings",
      JSON.stringify(userProfile.userSettings)
    );
  }, [userProfile.userSettings]);

  //-----
  const updateUser = (newUser) => {
    setUserProfile((prevUser) => ({
      ...prevUser,
      ...newUser,
    }));
  };

  const logoutRemoveProfile = async () => {
    //Remove user profile from context state
    setUserProfile({
      username: "",
      role: "guest",
      password: "",
      phone: "",
      email: "",
      profilePicture: "",
      parcela: "", // EN: parcela, ES: parcela
      poligono: "", // EN: polygon, Poligono
      catastro: "", // EN: Cadastre, ES: Catastro
      isUserAGuest: false,
      //profilePicture: ProfilePic,
      isOnline: true,
      userSettings: {
        apiCallFrequency: 5,
        enableNotifications: true,
        notificationChannels: {
          email: true,
          push: true,
          whatsapp: true,
        },
        notificationTypes: {
          watering: true,
          maintenance: true,
          incidents: true,
        },
        consentToCookies: true,
        consentToPersonalData: true,
        cookiePreferences: "essential", // "necessary", "preferences", "statistics", "marketing"
        whoCanContact: "everyone",
        darkMode: "system", // "light", "dark", "system" en db
        // https://tailwindcss.com/docs/dark-mode for dark mode to be "true", "false" or "auto"
        fontSize: "16px",
        sidebarPosition: "left", // "left" or "right" or maybe in the future - "bottom"
        layoutMode: "simple",
        dashboardLayout: frontLayouts["simple"], // should be "example-1 for demo" //sorted
        widgets: widgetData,
        storedWidgets: [],
      },
      contactDetails: {
        firstName: "",
        lastName: "",
        workRole: "",
        bio: "",
        phone: "",
        contactMail: "",
        allowWhatsapp: true,

        address: {
          city: "",
          state: "",
          country: "",
          postalCode: "",
          street: "",
        },
      },
    });
  };

  //-----END MANAGE USER PROFILE

  //-----MANAGE SENSOR TELEMETRY------
  //Mock fetchSensorsDataLast5 to rest re-rendering of widgets in analiticas
  const generateMockData = (deviceId, numEntries = 1) => {
    const now = new Date();
    const generateDate = (daysAgo, secondsAgo) => {
      const date = new Date(now);
      date.setDate(now.getDate() - daysAgo);
      date.setSeconds(now.getSeconds() - secondsAgo);
      return date;
    };

    const generateValue = (base, variation) => {
      return (base + (Math.random() * variation - variation / 2)).toFixed(2);
    };

    const mockData = [];
    for (let i = 0; i < numEntries; i++) {
      mockData.push({
        recvtime: generateDate(i, i * 10), // each entry is 10 seconds apart
        pressure: generateValue(1.5, 0.5), // random value around 1.5
        temperature: generateValue(25, 5), // random value around 25
        flow: generateValue(3.0, 1.0), // random value around 3.0
      });
    }
    return mockData;
  };

  // eslint-disable-next-line no-unused-vars
  const MockfetchSensorsData = async (amount) => {
    const mockData = {
      ...Object.keys(sensorCoordinates).reduce((acc, key) => {
        acc[key] = generateMockData(key, amount);
        return acc;
      }, {}),
    };

    return {
      statusCode: 200,
      body: JSON.stringify(mockData),
    };
  };

  // Retained for reference by the dormant mock telemetry path.
  // eslint-disable-next-line no-unused-vars
  const transformLegacyData = (data) => {
    //console.log("ContextProvider fetchSensorsData transformData data:", data);

    const formatValue = (value) => {
      // If value is null or undefined, return "0"
      if (value === null || value === undefined) {
        return "0";
      }

      //Convert the value to a number, replace negative values with 0, and format to two decimal places
      const numericValue = parseFloat(value);
      if (isNaN(numericValue) || numericValue < 0) {
        return "0";
      }
      return numericValue.toFixed(2);
    };

    return Object.keys(data).map((deviceId) => {
      //Get coordinates from sensorCoordinates based on deviceId
      const coordinates = sensorCoordinates[deviceId]
        ? [
            sensorCoordinates[deviceId].coordx,
            sensorCoordinates[deviceId].coordy,
          ]
        : [0, 0]; // Default coordinates if deviceId not found
      const coordinates3d = sensorCoordinates[deviceId]
        ? [
            sensorCoordinates[deviceId].coordx3d,
            sensorCoordinates[deviceId].coordy3d,
          ]
        : [0, 0]; //Default coordinates if deviceId not found

      //Original code dealt with the function fetchSensorsDataLast5() that fetches the latest 5 sensor's data in an array of objects. So it used this:
      //measurements: data[deviceId].map(d => ({
      //Now depending on the function used: fetchSensorsDataLast5() or fetchSensorsDataLatest() it needs to figure out if it's an array or a single object.

      //Determine if the data for the deviceId is an array or a single object
      const measurementsData = Array.isArray(data[deviceId])
        ? data[deviceId]
        : [data[deviceId]];

      //console.log(`ContextProvider fetchSensorsData transformData: ${deviceId}, data:`, measurementsData);
      //console.log("ContextProvider fetchSensorsData measurementsData:", measurementsData);

      return {
        id: uuidv4(),
        deviceId,
        title: sensorCoordinates[deviceId]?.title || `Sensor ${deviceId}`,
        notifications: [],
        location: {
          city: "Valencia", // TODO Unknown
          specificLocation: "Marjals i Extremals", // TODO Unknown
          coordinates: coordinates,
          coordinates3d: coordinates3d,
        },
        timeFrame: {
          start: "",
          end: "",
        },
        data: [
          {
            category: "pressure",
            measurements: measurementsData
              .map((d) => {
                let date = new Date(d.recvtime);
                date.setHours(date.getHours() + 1); // Keep as Date object with added 2 hours
                return {
                  date: date,
                  value: formatValue(d.pressure), //d.pressure,
                  unit: "bar",
                };
              })
              .filter((d) => d.value !== null),
          },
          {
            category: "temperature",
            measurements: measurementsData
              .map((d) => {
                let date = new Date(d.recvtime);
                date.setHours(date.getHours() + 1); // Keep as Date object with added 2 hours. 2 hours ahead of DB's date and time in summer and 1 hour in winter.
                return {
                  date: date,
                  value: formatValue(d.temperature), //d.temperature,
                  unit: "°C",
                };
              })
              .filter((d) => d.value !== null),
          },
          {
            category: "flow",
            measurements: measurementsData
              .map((d) => {
                let date = new Date(d.recvtime);
                date.setHours(date.getHours() + 1); // Keep as Date object with added 2 hours
                return {
                  date: date,
                  value: formatValue(d.flow), //d.flow,
                  unit: "m³/s",
                };
              })
              .filter((d) => d.value !== null), //.filter(d => d.value !== null && d.value !== "0")
          },
        ],
      };
    });
  };

  const transformData = useCallback(
    (data) => transformProjectSensorData(data),
    []
  );

  //Get devices
  const fetchSensorsDataFromAPI = useCallback(async (isFullUpdate = false) => {
    try {
      const currentProjectId = userProfile?.currentProjectId;
      if (!currentProjectId) {
        if (isFullUpdate) setUnifiedData([]);
        return;
      }

      const data = await loadProjectSensorData(currentProjectId, {
        latest: !isFullUpdate,
      });
      const transformedData = transformData(data);
      setUnifiedData((prevData) => {
        if (isFullUpdate || prevData.length === 0) return transformedData;
        return mergeLatestSensorData(prevData, transformedData);
      });
      setLatestUpdateTime(new Date());
    } catch (error) {
      console.error("Error fetching sensor data:", error.message);
    } finally {
      setIsLoading(false);
    }
  }, [transformData, userProfile?.currentProjectId]);
  //console.log("ContextProvider unifiedData: ",unifiedData);

  /* useEffect(() => {
      fetchSensorsDataFromAPI();
  }, [isAuthenticated]); */

  //Original code. Fetches whatevery function is configured in fetchSensorsDataFromAPI()
  /* useEffect(() => {
    let intervalId, fullUpdateIntervalId;

    if (isAuthenticated) {
      fetchSensorsDataFromAPI();

      //Fetch sensorsData every 10 seconds (time interval set by the user)
      intervalId = setInterval(() => {
        fetchSensorsDataFromAPI();
      }, 10000); //10 seconds interval 

      //TEST ¿updating analiticas page every 5 minutes? 
      fullUpdateIntervalId = setInterval(() => {
        fetchSensorsDataFromAPI(true); //Full update
      }, 300000); //Every 5 minutes
    }

    return () =>  {
      clearInterval(intervalId);
      clearInterval(fullUpdateIntervalId);
    }
  }, [isAuthenticated]); */

  //A little modification of the former useEffect. Fetches initially the last 5 records of every sensor and then only the latest
  const startDataFetching = useCallback(
    (isAuthenticated, fetchSensorsDataFromAPI) =>
      startSensorPolling(
        isAuthenticated && Boolean(userProfile?.currentProjectId),
        () => fetchSensorsDataFromAPI(true),
        () => fetchSensorsDataFromAPI(false)
      ),
    [userProfile?.currentProjectId]
  );

  useEffect(() => {
    const cleanup = startDataFetching(isAuthenticated, fetchSensorsDataFromAPI);
    return cleanup;
  }, [isAuthenticated, fetchSensorsDataFromAPI, startDataFetching]);

  //TEST. Trigger a full update Based on Data Volume, when the appended data exceeds a certain volume
  /* useEffect(() => {
    if (unifiedData.length > 100) { //Threshold for full update
      fetchSensorsDataFromAPI(true); //Full update
    }
  }, [unifiedData]); */

  /* useEffect(() => {
    const data  = getDynamicData();
    setUnifiedData(data );
    console.log("ContextProvider unifiedData: ", unifiedData);
  }, [dataLoaded]); */

  //console.log("ContextProvider unifiedData outside useEffect: ", unifiedData);

  /* const contextValue = {
    unifiedData,
    widgetData: widgetData(unifiedData),
    // ... other context values
  }; */

  //------------END MANAGE DATA RETRIEVED FROM SENSORS---------

  //-----WIDGETS AND LAYOUTS----------
  const handleUpdateWidgetType = (widgetId, newType) => {
    updateWidgetType(widgetId, newType, userProfile, setUserProfile);
  };

  const handleUpdateWidgetOptions = (widgetId, newOptions) => {
    updateWidgetOptions(widgetId, newOptions, userProfile, setUserProfile);
  };
  const handleResetFrontLayout = () => {
    resetFrontLayout(frontLayouts, userProfile, setUserProfile);
  };

  // Put to helper
  const handleSetWidgetDefaultOptions = (widgetId, newType) => {
    setWidgetDefaultOptions(
      widgetId,
      newType,
      availableWidgets,
      userProfile,
      setUserProfile
    );
  };

  const handleAddWidget = (widgetType) =>
    addWidget(
      widgetType,
      availableWidgets,
      unifiedData,
      userProfile,
      setUserProfile
    );

  const handleRemoveWidget = (widgetId) => {
    if (widgetId !== "mapGis") {
      removeWidget(widgetId, userProfile, setUserProfile);
    } else {
      console.log("ContextProvider Cannot remove mapGis widget");
    }
  };
  const handleStoreWidget = (widgetId) => {
    storeWidget(widgetId, userProfile, setUserProfile);
    removeWidget(widgetId, userProfile, setUserProfile);
  };
  const handleRestoreStoredWidget = (widgetId) =>
    restoreStoredWidget(widgetId, userProfile, setUserProfile);

  const setDashboardLayoutByName = (layoutName, navigateTo) => {
    try {
      console.log(
        "ContextProvider setDashboardLayoutByName layoutName:",
        layoutName
      );
      console.log(
        "ContextProvider setDashboardLayoutByName navigateTo:",
        navigateTo
      );

      if (layoutName) {
        setUserProfile((prevProfile) => {
          if (!prevProfile || !prevProfile.userSettings) {
            console.error("Invalid profile structure", prevProfile);
            return prevProfile; // Early return if structure is invalid
          }

          const updatedProfile = {
            ...prevProfile,
            userSettings: {
              ...prevProfile.userSettings,
              layoutMode: layoutName,
              // dashboardLayout: frontLayouts[navigateTo ? navigateTo : layoutName],
            },
          };

          localStorage.setItem("userProfile", JSON.stringify(updatedProfile));
          return updatedProfile;
        });
        // setTimeout(() => {
        //   handleSetLayout(navigateTo);
        // }
        // , 500);
      } else {
        console.error("Layout not found:", layoutName);
      }
    } catch (error) {
      console.error("Error in setDashboardLayoutByName:", error);
    }
  };

  const toggleDarkMode = () => {
    setUserProfile((prevState) => ({
      ...prevState,
      userSettings: {
        ...prevState.userSettings,
        darkMode:
          prevState.userSettings.darkMode === "light"
            ? "dark"
            : prevState.userSettings.darkMode === "dark"
            ? "light"
            : "dark",
      },
    }));
  };

  //-------END WIDGETS AND LAYOUTS-----------------

  return (
    <StateContext.Provider
      value={{
        // handleClick,
        updateUser,
        toggleDarkMode,
        // activeMenu,
        // setActiveMenu,
        // isClicked, setIsClicked,
        // screenSize,
        // setScreenSize,
        // showIconsOnly,
        // setShowIconsOnly,
        // activeAppbar, setActiveAppbar,
        activeLoginForm,
        setActiveLoginForm,
        userProfile,
        setUserProfile,
        selectedEvent,
        setSelectedEvent,
        selectedEventId,
        setSelectedEventId,
        handleAddWidget,
        handleRemoveWidget,
        handleStoreWidget,
        handleRestoreStoredWidget,
        addWidget,
        removeWidget,
        storeWidget,
        restoreStoredWidget,
        handleSetLayout,
        latestUpdateTime,
        // setLatestUpdateTime,
        handleResetFrontLayout,
        setDashboardLayoutByName,
        isEditingDashboardLayout,
        setIsEditingDashboardLayout,
        handleUpdateWidgetOptions,
        handleUpdateWidgetType,
        handleSetWidgetDefaultOptions,
        fetchSensorsDataFromAPI, // test to add refresh button to page
        // handleSetDashboardLayoutByName,
        activeLinkName,
        setActiveLinkName,
        activeComponent,
        setActiveComponent,
        //
        logoutRemoveProfile,
        sensorsDataLatest,
        setSensorsDataLatest,
        sensorsDataLast5,
        setSensorsDataLast5,
        isLoading,
        setIsLoading,
        isLoadingUserPermissions,
        setIsLoadingUserPermissions,
        unifiedData,
        userData,
        setUserData,
        //contextValue,
        //widgetData: widgetData(unifiedData),
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

/**We use the activeMenu inside the components of the app by exporting the useStateContext.
 * It's a function that returns the calls to the useContext but we pass which context will we wanna use.
 * Nemo tip: "Give me the data from the context (useStateContext) by using the context (useContext) and we specify which one (StateContext)"
 * In this app we'll have one context but in bigger applications we can have multiple context providers.
 */
export const useStateContext = () => useContext(StateContext);
